import React from 'react';
import { Row, Col, Typography } from 'antd';
import {
  FileTextOutlined,
  FileDoneOutlined,
  DollarOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
import StatCard from '../../../components/common/StatCard';
import { formatCurrency } from '../../../utils/format';

const { Text, Title } = Typography;

const OverviewSection = ({ loading, stats }) => (
  <Row gutter={[24, 24]} align="top">
    <Col xs={24} md={8}>
      <Title level={5} className="customer-dashboard-section-title">
        Overview
      </Title>
      <Text type="secondary" className="customer-dashboard-section-text">
        A quick snapshot of your invoices, balances, and estimates in the portal.
      </Text>
    </Col>
    <Col xs={24} md={16}>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} xl={12} xxl={6}>
          <StatCard
            loading={loading}
            title="Total Invoices"
            value={stats?.total_invoices ?? 0}
            icon={<FileTextOutlined />}
            color="var(--varexe-primary)"
          />
        </Col>
        <Col xs={24} sm={12} xl={12} xxl={6}>
          <StatCard
            loading={loading}
            title="Outstanding Balance"
            value={formatCurrency(stats?.total_amount_outstanding)}
            icon={<DollarOutlined />}
            color="var(--varexe-warning)"
          />
        </Col>
        <Col xs={24} sm={12} xl={12} xxl={6}>
          <StatCard
            loading={loading}
            title="Paid Invoices"
            value={stats?.paid_invoices ?? 0}
            icon={<CheckCircleOutlined />}
            color="var(--varexe-success)"
          />
        </Col>
        <Col xs={24} sm={12} xl={12} xxl={6}>
          <StatCard
            loading={loading}
            title="Total Estimates"
            value={stats?.total_estimates ?? 0}
            icon={<FileDoneOutlined />}
            color="var(--varexe-info)"
          />
        </Col>
      </Row>
    </Col>
  </Row>
);

export default OverviewSection;
